import React from "react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

export default function OtherPostsHelpDialog({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>İkonların ve Alanların Anlamları</DialogTitle>

      <DialogContent dividers>
        <List>
          <ListItem>
            <ListItemText
              primary="İlan durumu hakkında"
              secondary={
                <>
                  ✅ Aktif ilan: Sistemde manuel oluşturulmuş ya da sistem
                  tarafından uygun görülüp eklenmiş duyurular, aktif olarak
                  sitemizde "İş İlanları" bölümünde görünür şekilde kaydedilir.
                  <br />
                  ❌ Pasif ilan: Bir ilanın tarihi geçmişse veya geçici olarak
                  kaldırılması gerekiyorsa kullanılır.
                  <br />
                  🗑️ Gereksiz ilan: Gereksiz bulunan, sistem tarafından çekilen
                  ve biyomedikal mühendislerinin çalışmasına uygun olmayan ilanlar
                  sistem tarafından gereksiz olarak işaretlenir.
                </>
              }
            />
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <LinkedInIcon style={{ color: "#0d0d0eff" }} />
            </ListItemIcon>
            <ListItemText
              primary="LinkedIn paylaşma durumu"
              secondary="İlanın LinkedIn’de paylaşılma durumunu gösterir."
            />
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <span style={{ fontSize: 20 }}>🤖</span>
            </ListItemIcon>
            <ListItemText
              primary="İlanın biyomedikal mühendisliğine uygunluğu (AI)"
              secondary="Sistem veya yapay zeka tarafından ilan biyomedikal mühendisliği açısından uygun bulunmuştur. Bu sistem sadece duyurunun otomatik olarak LinkedIn tarafında paylaşması için gereklidir."
            />
          </ListItem>

          <ListItem alignItems="flex-start">
            <ListItemIcon>
              <span style={{ fontSize: 24 }}>🤖💤</span>
            </ListItemIcon>
            <ListItemText
              primary="İlanın biyomedikal mühendisliğine uygunluğu bekleniyor (AI)"
              secondary={
                <div style={{ lineHeight: 1.6 }}>
                  <p>Sistem veya yapay zeka bu duyuruyu henüz gözden geçirmemiştir.</p>
                  <p>
                    Sistem Türkiye saatiyle ogleden sonra 5'de çekip sisteme eklenen
                    yeni duyuruları, saat aksam 7'de incelemeye başlar ve uygunluğuna
                    karar verir.
                  </p>
                  <p>
                    Bu emojiyi görüyorsanız, sistem bu duyuruyu daha gözden geçirmemiş
                    demektir. İşlem bitene kadar bekleyiniz.(İşlem yoğunlğa göre 1-2 saat sürebilir)
                  </p>
                </div>
              }
            />
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <span style={{ fontSize: 20 }}>⚙️</span>
            </ListItemIcon>
            <ListItemText
              primary="Sistem Tarafından Eklendi"
              secondary="Bu ilan sistem tarafından otomatik olarak eklenmiştir."
            />
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <span style={{ fontSize: 20 }}>🚫</span>
            </ListItemIcon>
            <ListItemText
              primary="Otomatik Linkedin Sistemi öncesi eklemiş duyuru"
              secondary="Bu ilan otomatik Linkedin Sistemi tamamlanmadan veya daha öncesinde eklenen bir duyurudur ai bu duyuruya bakmamıştır."
            />
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <LinkedInIcon style={{ color: "#0A66C2" }} />
            </ListItemIcon>
            <ListItemText
              primary="Yanıp sönen LinkedIn logosu (LinkedIn Paylaşımı için sırada)"
              secondary={
                <div style={{ lineHeight: 1.6 }}>
                  <p>
                    Bu ikonu gördüyseniz ve eğer ilan uygunluğu değişmez 🤖 ise{" "}
                    <b style={{ color: "red" }}>
                      güncel oldugunuz günün bir önceki gününde yayınlanan ilanı
                    </b>{" "}
                    saat <b style={{ color: "black" }}>10:00’da</b> sistem tarafından
                    30 dakika araliklarla otomatik LinkedIn’e paylaşılacaktır.
                  </p>
                  <p>
                    Eğer ilanın AI tarafından uygunluğunun yanlış olduğunu düşünüyorsanız,
                    <b style={{ color: "black" }}> Güncelle</b> menüsünden ilanın uygunluğunu
                    değiştirebilir ve sistemin otomatik olarak paylaşmasını engelleyebilirsiniz.
                  </p>
                  <p>
                    Aynı şekilde, isterseniz sistemi beklemeden kendiniz de duyuruyu{" "}
                    <b style={{ color: "black" }}>LinkedIn paylaş</b> butonuyla yapabilirsiniz.
                  </p>
                  <p style={{ color: "red", lineHeight: 1.6, fontWeight: "bold" }}>
                    Otomatik paylaşım için Uygunluk değişimini gün içinde{" "}
                    <b>saat sabah 10:00'dan önce</b> yapınız. Daha sonrasında yaparsanız,
                    bu emojinin bir anlamı olmayacak ve paylaşımı elle yapmanız gerekecektir.
                  </p>
                </div>
              }
            />
          </ListItem>
        </List>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary">
          Kapat
        </Button>
      </DialogActions>
    </Dialog>
  );
}